import { render, staticRenderFns } from "./AddIssues.vue?vue&type=template&id=360f8657&"
import script from "./AddIssues.vue?vue&type=script&lang=ts&"
export * from "./AddIssues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360f8657')) {
      api.createRecord('360f8657', component.options)
    } else {
      api.reload('360f8657', component.options)
    }
    module.hot.accept("./AddIssues.vue?vue&type=template&id=360f8657&", function () {
      api.rerender('360f8657', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/issues/AddIssues.vue"
export default component.exports